import React from "react";
import DataTable from "../../../components/DataTable";

const DocumentTypes = () => (
  <DataTable
    title="Document Types"
    apiPath="/api/admin/master/document-types"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
    ]}
    formFields={[
      { key: "name", label: "Document Type Name", required: true },
    ]}
  />
);

export default DocumentTypes;
